import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { ResizeHandle } from './resize-handle.atom'

interface ResizableDrawerDesktopProps {
  isOpen: boolean
  drawerWidth: number
  onResize: (deltaX: number) => void
  children: ReactNode
  className?: string
}

/**
 * Generic desktop drawer shell with resize handle.
 * Fixed position, slides in from right, with configurable width.
 */
export const ResizableDrawerDesktop = ({
  isOpen,
  drawerWidth,
  onResize,
  children,
  className,
}: ResizableDrawerDesktopProps): ReactNode => {
  if (!isOpen) return null

  return (
    <div
      className={cn(
        'resizable-drawer-desktop fixed inset-y-0 right-0 z-50 flex bg-background shadow-xl will-change-transform',
        'animate-in slide-in-from-right duration-300',
        className
      )}
      style={{ width: drawerWidth }}
    >
      <ResizeHandle onResize={onResize} className="shrink-0" />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{children}</div>
    </div>
  )
}

ResizableDrawerDesktop.displayName = 'ResizableDrawerDesktop'
